import yumurta from "./yumurta.png"

import not_yet from "./not_yet.mp3";

import uuid from 'uuid-random';

import {songs as songs_2020, images as images_2020 } from "../2020/index.ts";

let id = 0;
export const images = [
    { image: yumurta, id: uuid()},
];

export const songs = [
    { song: not_yet, title: "Not Yet", artist: "Jenn Bostic", id: uuid() },
];

export const acoustic_images = [
    images_2020[Math.floor(Math.random() * songs_2020.length)],
    images_2020[Math.floor(Math.random() * songs_2020.length)],
];

export const acoustic_songs = [
    songs_2020[Math.floor(Math.random() * songs_2020.length)],
    songs_2020[Math.floor(Math.random() * songs_2020.length)]
];